<template>
  <div class="page-container">
    <div class="logo-wrapper">
      <AnimatedLogo />
    </div>
  </div>
</template>

<script>
import AnimatedLogo from './AnimatedLogo.vue';

export default {
  components: { AnimatedLogo }
};
</script>

<style scoped>
.page-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999999999999;
  background-color: rgba(100, 99, 99, 0.8);
  backdrop-filter: blur(5px);
}

.logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
